<template>
    <div>
      <nav-breadcrumb :menu="[{label: ' 渠道商用户列表'}]"/>
      <div class="xzpadd10 bg-purple of">
        <data-table
          :table-data="tableData"
          :columns="columns"
          :page.sync="page"
          :pageSize.sync="pageSize"
          :filters.sync="filters"
          :actions="actions"
        />
      </div>
    </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import Status2CN from "../../filters/Status2CN";
  import {removeItem} from "../../filters/CommonActions";
    export default {
        name: "DealerUserList",
        data(){
            return{
              columns:[
                {
                  type: 'index'
                },
                {
                  label: '姓名',
                  field: 'du__userName'
                },
                {
                  label: '渠道商名称',
                  field: 'd__dealerName'
                },
                {
                  label: '渠道商编号',
                  field: 'd__dealerCode'
                },
                {
                  label: '手机号',
                  field: 'du__mobileNo'
                },
                {
                  label: '角色',
                  field: 'r__role'
                },
                {
                  label: '状态',
                  field: 'du__disabled',
                  formatter: function (r,c,v) {
                    return Status2CN(v)
                  }
                },
                {
                  label: '操作',
                  opts:[
                    {
                      label: '编辑',
                      class: 'el-icon-edit',
                      clickHandler: (index, row)=> {
                        this.$router.push(
                          {
                            path: 'add',
                            query: {
                              userId: row.du__userId
                            }
                          }
                        )
                      }
                    },
                    {
                      label: '删除',
                      class: 'el-icon-delete',
                      clickHandler: (index, row)=>{
                        this.removeItem(index, row)
                      }
                    }
                  ]
                }
              ],
              tableData: {
                count: 0,
                data: []
              },
              dealerTypeOptions:[],
              page: 1,
              pageSize: 20,
              actions: [
                {
                  label: '新增',
                  class: 'el-button--primary',
                  clickHandler: ()=>{
                    this.$router.push({
                      path: 'add'
                    })
                  }
                }
              ],
              filters: {
                labelWidth: '150px',
                form: {
                  du__userName:'',
                  d__dealerId:'',
                  d__dealerCode:'',
                  du__mobileNo:'',
                  r__role:'',
                },
                columns: [
                  {
                    label: '姓名',
                    component: 'el-input',
                    field: 'du__userName'
                  },
                  {
                    label: '渠道商名称',
                    component: 'el-select',
                    field: 'd__dealerId',
                    options:[]
                  },
                  {
                    label: '渠道商编号',
                    component: 'el-input',
                    field: 'd__dealerCode'
                  },
                  {
                    label: '手机号',
                    component: 'el-input',
                    field: 'du__mobileNo'
                  },
                  {
                    label: '角色',
                    component: 'el-select',
                    field: 'r__role',
                    filterable: true,
                    options: [
                      {
                        label:'渠道商 进件',
                        value:'渠道商 进件',
                      },
                      {
                        label:'渠道商 初审',
                        value:'渠道商 初审',
                      },
                      {
                        label:'渠道商 内勤',
                        value:'渠道商 内勤',
                      }
                    ]
                  },



                ],
                onSubmit:()=>{
                  this.page = 1
                  this.getData()
                }
              }
            }
        },
        mounted() {
          this.getData()
          this.getDealerList()
        },
        computed: {
          filterParams() {
            return {
              pageSize: this.pageSize,
              pageOffset: (this.page - 1) * this.pageSize,
            }
          }
        },
        watch: {
          filterParams: function (newVal) {
            this.getData()
          }
        },
        methods: {
          getData: function () {
            xhr.getDealerUserList(
              Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
              res=> {
                try {
                  this.tableData = res.data
                }catch(e){

                }
              })

          },
          removeItem: function (index, row) {
            removeItem(
              xhr.updateDealerUser,
              {
                'du.userId' : row.du__userId
              },
              res=>{
                try {
                  console.log(res.data.status)
                  if(res.data.status == 'success') {
                    this.getData()
                  }
                }catch (e) {

                }
              }
            )
          },
          getDealerList: function () {
            xhr.getDealerList(
              Object.assign({pageSize:0}, {}, {}),
              res=> {
                try {
                  this.filters.columns[1].options = res.data.data.map(item=>{
                    return {
                      label: item.d__dealerName,
                      value:item.d__dealerId,
                    }
                  })
                }catch(e){

                }
              })

          },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/DealerUserList.vue